export const CUSTOMER_ROLE = 0;
export const SUPPLIER_ROLE = 1;
export const CUSTOMER_ADMIN = 'CUSTOMER_ADMIN';
export const ORDER_LIST = 'ORDER_LIST'; 
export const REPORTING = 'REPORTING';

export const FEATURES = {
  MENU_CAMPAIGN_WITH_ORDER: 'menuCampaignWithOrder',
  WITH_GIFT: 'withGift',
  COLLECTING_DATA: 'collectingData',
};

export const menuItems = [

  ///////////////////
  // Customer Menu 
  {
    title: 'Dashboard',
    hiddenOnCollapse: true,
    type: 'header',
    role: CUSTOMER_ROLE,
    isForAdmin: true,
    },

    {
      id: 2,
      label: 'Ventes',
      icon: 'fas fa-shopping-cart',
      subItems: [],
      link: '/analytics/sales',
      role: CUSTOMER_ROLE,
      isForAdmin: true,
    },

    {
      id: 3,
      label: 'Analytics',
      icon: 'fas fa-chart-area',
      subItems: [],
      link: '/analytics',
      role: CUSTOMER_ROLE,
      isForAdmin: true,
    },

    {
      id: 4,
      label: 'Performance',
      icon: 'fas fa-tachometer-alt',
      subItems: [],
      link: '/analytics/menu',
      role: CUSTOMER_ROLE,
      isForAdmin: true,
    },

    {
      id: 5,
      label: 'Analyse clients',
      icon: 'fas fa-chart-area',
      subItems: [],
      link: '/analytics/customer',
      role: CUSTOMER_ROLE,
      isForAdmin: true,
    },

  
  {
    id: 6,
    label: 'Données collectées',
    icon: 'fas fa-database',
    subItems: [],
    link: '/data',
    role: CUSTOMER_ROLE,
    requires: [FEATURES.COLLECTING_DATA],
    isForAdmin: true,
  },

  {
    hiddenOnCollapse: true,
    type: 'header',
    isCampaignName: true,
    role: CUSTOMER_ROLE,
  },

  {
    id: 7,
    label: 'Gadeaux Gagnés',
    icon: 'fas fa-gift',
    subItems: [],
    link: '/winner-gift',
    role: CUSTOMER_ROLE,
    requires: [FEATURES.WITH_GIFT],
    isForAdmin: true,
  },


  {
    id: 8,
    label: 'Réglage menu',
    icon: 'fa fa-list',
    link: '/settings/menu',
    role: CUSTOMER_ROLE,
  },


  {
    id: 9,
    label: 'Réglage QR Code',
    icon: 'fas fa-qrcode',
    link: '/settings/qrCode',
    role: CUSTOMER_ROLE,
  },


  {
    id: 10,
    label: 'Réglage commande',
    icon: 'fa fa-shopping-cart',
    link: '/settings/order',
    role: CUSTOMER_ROLE,
    requires: [FEATURES.MENU_CAMPAIGN_WITH_ORDER],
    isForAdmin: true,
  },


  {
    title: 'Commandes',
    hiddenOnCollapse: true,
    type: 'header',
    role: CUSTOMER_ROLE,
    requires: [FEATURES.MENU_CAMPAIGN_WITH_ORDER],
  },


  {
    id: 11,
    label: 'Commandes',
    icon: 'fas fa-th',
    link: '/menu-order',
    role: CUSTOMER_ROLE,
    requires: [FEATURES.MENU_CAMPAIGN_WITH_ORDER],
  },

  {
    id: 12,
    label: 'Historique Commandes',
    icon: 'fa fa-list-alt',
    link: '/order/history',
    role: CUSTOMER_ROLE,
    requires: [FEATURES.MENU_CAMPAIGN_WITH_ORDER],
    isForAdmin: true,
  },

  {
    title: 'Utilisateur',
    hiddenOnCollapse: true,
    type: 'header',
    role: CUSTOMER_ROLE,
    isForAdmin: true,
  },

  {
    id: 13,
    label: 'Profil',
    icon: 'fas fa-user',
    subItems: [],
    link: '/profil',
    role: CUSTOMER_ROLE,
  },

  {
    id: 14,
    label: 'Se déconnecter',
    icon: 'fas fa-power-off',
    subItems: [],
    link: '/logout',
    role: CUSTOMER_ROLE,
  },

  ///////////////////
  // Supplier Menu 


    {
      title: 'Dashboard',
      hiddenOnCollapse: true,
      type: 'header',
      role: SUPPLIER_ROLE,
    },

    
    {
      id: 101,
      label: 'Ventes',
      icon: 'fas fa-shopping-cart',
      subItems: [],
      link: '/analytics/sales',
      role: SUPPLIER_ROLE,
    },

    {
      id: 102,
      label: 'Analytics',
      icon: 'fas fa-chart-pie',
      subItems: [],
      link: '/analytics',
      role: SUPPLIER_ROLE,
    },

    {
      id: 121,
      label: 'Performance',
      icon: 'fas fa-tachometer-alt',
      subItems: [],
      link: '/analytics/menu',
      role: SUPPLIER_ROLE,
    },

    {
      id: 122,
      label: 'Analyse clients',
      icon: 'fas fa-chart-area',
      subItems: [],
      link: '/analytics/customer',
      role: SUPPLIER_ROLE,
    },

    {
      id: 103,
      label: 'Données collectées',
      icon: 'fas fa-database',
      subItems: [],
      link: '/data',
      role: SUPPLIER_ROLE,
      requires: [FEATURES.COLLECTING_DATA],

    },

    {

      hiddenOnCollapse: true,
      type: 'header',
      isCampaignName: true,
      role: SUPPLIER_ROLE,
    },

    {
    id: 108,
    label: 'Réglage menu',
    icon: 'fa fa-list',
    link: '/settings/menu',
    role: SUPPLIER_ROLE,
  },

  {
    id: 107,
    label: 'Réglage QR Code',
    icon: 'fa fa-qrcode',
    link: '/settings/qrCode',
    role: SUPPLIER_ROLE,
  },


  {
    id: 109,
    label: 'Réglage commande',
    icon: 'fa fa-shopping-cart',
    link: '/settings/order',
    role: SUPPLIER_ROLE,
    requires: [FEATURES.MENU_CAMPAIGN_WITH_ORDER],
  },

  {
    id: 104,
    label: 'Gadeaux Gagnés',
    icon: 'fas fa-gift',
    subItems: [],
    link: '/winner-gift',
    role: SUPPLIER_ROLE,
    requires: [FEATURES.WITH_GIFT],
  },

  {
    title: 'Commandes',
    hiddenOnCollapse: true,
    type: 'header',
    role: SUPPLIER_ROLE,
    requires: [FEATURES.MENU_CAMPAIGN_WITH_ORDER],
  },

  {
    id: 110,
    label: 'Commandes',
    icon: 'fa fa-th',
    link: '/menu-order',
    role: SUPPLIER_ROLE,
    requires: [FEATURES.MENU_CAMPAIGN_WITH_ORDER],
  },

  {
    id: 111,
    label: 'Historique Commandes',
    icon: 'fa fa-list-alt',
    link: '/order/history',
    role: SUPPLIER_ROLE,
    requires: [FEATURES.MENU_CAMPAIGN_WITH_ORDER],
  },

  {
    title: 'Admin',
    hiddenOnCollapse: true,
    type: 'header',
    role: SUPPLIER_ROLE,
  },


  {
    id: 105,
    label: 'Menus',
    icon: 'fas fa-layer-group',
    link: '/campaign',
    role: SUPPLIER_ROLE,
  },

  {
    id: 112,
    label: 'Utilisateurs',
    icon: 'fas fa-users',
    link: '/utilisateurs',
    role: SUPPLIER_ROLE,
  },

  {
    id: 113,
    label: 'Système',
    icon: 'fas fa-cogs',
    subItems: [],
    link: '/bannieres',
    role: SUPPLIER_ROLE,
  },

  {
    id: 114,
    label: 'Devis',
    icon: 'fas fa-file-invoice-dollar',
    subItems: [],
    link: '/demande/devis',
    role: SUPPLIER_ROLE,
  },
  
  {
    title: 'Utilisateur',
    hiddenOnCollapse: true,
    type: 'header',
    role: SUPPLIER_ROLE,
  },


  {
    id: 115,
    label: 'Profil',
    icon: 'fas fa-user',
    subItems: [],
    link: '/profil',
    role: SUPPLIER_ROLE,
  },

  {
    id: 116,
    label: 'Se déconnecter',
    icon: 'fas fa-power-off',
    subItems: [],
    link: '/logout',
    role: SUPPLIER_ROLE,
  },

];
